import { FunctionComponent } from 'react'
import { useSelector } from 'react-redux'
import classNames from 'classnames'
import { FavoritesButtonProps } from './FavoritesButton.types'
import { Button } from '../primitives/Button/Button'
import { useMealFavorite } from 'src/hooks/useMealFavorite'
import { useMeals } from 'src/pages/orders/components/Main/Delivery/useMeals'
import tracking from 'src/shared/tracking'
import { getProfiles } from 'src/modules/MyDeliveries/selectors'
import { IconType } from '../primitives/Icon/Icon.types'
import { ButtonUXType } from '../primitives/Button/Button.types'
import {
  UXComponentType,
  UXComponentVersion
} from '../UXComponentRenderer/uxComponent.types'
import './FavoritesButton.scss'

export const FavoritesButton: FunctionComponent<FavoritesButtonProps> = ({
  className,
  attributes,
  entityId,
  ...otherProps
}) => {
  const profiles = useSelector(getProfiles)
  const isFavorite = !!profiles?.some(profile =>
    profile.mealWishes.some(wish => wish.mealId === Number(entityId))
  )
  const { onLikeMeal, onUnLikeMeal } = useMeals()
  const { isLiked, toggleFavorite } = useMealFavorite({
    mealId: Number(entityId),
    isLikeMarked: isFavorite,
    onLike: onLikeMeal,
    onUnlike: onUnLikeMeal
  })

  const handleToggleFavorite = (e: React.MouseEvent) => {
    e.stopPropagation()

    if (isLiked) {
      attributes.actions?.onRemove?.forEach(action => {
        tracking.track(action.data.tag, action.data.extras)
      })
    } else {
      attributes.actions?.onAdd?.forEach(action => {
        tracking.track(action.data.tag, action.data.extras)
      })
    }

    toggleFavorite()
  }

  return (
    <Button
      attributes={{
        ...attributes,
        type: ButtonUXType.Icon,
        icon: {
          type: UXComponentType.Icon,
          version: UXComponentVersion.V1,
          attributes: {
            asset: isLiked ? IconType.HeartFilled : IconType.HeartOutline
          }
        }
      }}
      onClick={handleToggleFavorite}
      className={classNames('core-ux-favorites-button', className, {
        'core-ux-favorites-button--filled': isLiked
      })}
      {...otherProps}
    />
  )
}
